module.exports = __webpack_public_path__ + "media/images/icons/flags/DO-34d868708e24fee2d7eb638195194fcb.svg";